'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _pastPracticeTests = require('../actions/pastPracticeTests');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchPastPracticeTestsRequest),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchPastPracticeTestRequest),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(createPastPracticeTestRequest),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(editPastPracticeTestRequest),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(addQuestionsToPastPracticeTestRequest);

function fetchPastPracticeTestsRequest() {
    return regeneratorRuntime.wrap(function fetchPastPracticeTestsRequest$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(_pastPracticeTests.actionTypes.FETCH_PAST_PRACTICE_TESTS_REQUEST, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                        var response;
                        return regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) {
                                switch (_context.prev = _context.next) {
                                    case 0:
                                        _context.prev = 0;
                                        _context.next = 3;
                                        return (0, _effects.call)(_api.request, 'get', '/pastpracticetests');

                                    case 3:
                                        response = _context.sent;
                                        _context.next = 6;
                                        return (0, _effects.put)(_pastPracticeTests.actionCreators.fetchPastPracticeTestsSucceeded(response.data));

                                    case 6:
                                        _context.next = 12;
                                        break;

                                    case 8:
                                        _context.prev = 8;
                                        _context.t0 = _context['catch'](0);
                                        _context.next = 12;
                                        return (0, _effects.put)(_pastPracticeTests.actionCreators.fetchPastPracticeTestsFailed(_context.t0));

                                    case 12:
                                    case 'end':
                                        return _context.stop();
                                }
                            }
                        }, _callee, this, [[0, 8]]);
                    }));

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked, this);
}

function fetchPastPracticeTestRequest() {
    return regeneratorRuntime.wrap(function fetchPastPracticeTestRequest$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(_pastPracticeTests.actionTypes.FETCH_PAST_PRACTICE_TEST_REQUEST, /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref) {
                        var id = _ref.id;
                        var response;
                        return regeneratorRuntime.wrap(function _callee2$(_context3) {
                            while (1) {
                                switch (_context3.prev = _context3.next) {
                                    case 0:
                                        _context3.prev = 0;
                                        _context3.next = 3;
                                        return (0, _effects.call)(_api.request, 'get', '/pastpracticetests/' + id);

                                    case 3:
                                        response = _context3.sent;
                                        _context3.next = 6;
                                        return (0, _effects.put)(_pastPracticeTests.actionCreators.fetchPastPracticeTestSucceeded(response.data));

                                    case 6:
                                        _context3.next = 12;
                                        break;

                                    case 8:
                                        _context3.prev = 8;
                                        _context3.t0 = _context3['catch'](0);
                                        _context3.next = 12;
                                        return (0, _effects.put)(_pastPracticeTests.actionCreators.fetchPastPracticeTestFailed(_context3.t0));

                                    case 12:
                                    case 'end':
                                        return _context3.stop();
                                }
                            }
                        }, _callee2, this, [[0, 8]]);
                    }));

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked2, this);
}

function createPastPracticeTestRequest() {
    return regeneratorRuntime.wrap(function createPastPracticeTestRequest$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(_pastPracticeTests.actionTypes.CREATE_PAST_PRACTICE_TEST_REQUEST, /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref2) {
                        var pastPracticeTest = _ref2.pastPracticeTest,
                            redirect = _ref2.redirect;
                        var response;
                        return regeneratorRuntime.wrap(function _callee3$(_context5) {
                            while (1) {
                                switch (_context5.prev = _context5.next) {
                                    case 0:
                                        _context5.prev = 0;
                                        _context5.next = 3;
                                        return (0, _effects.call)(_api.request, 'post', '/pastpracticetests', pastPracticeTest);

                                    case 3:
                                        response = _context5.sent;
                                        _context5.next = 6;
                                        return (0, _effects.put)(_pastPracticeTests.actionCreators.createPastPracticeTestSucceeded(response.data));

                                    case 6:
                                        if (!redirect) {
                                            _context5.next = 9;
                                            break;
                                        }

                                        _context5.next = 9;
                                        return (0, _effects.call)(redirect);

                                    case 9:
                                        _context5.next = 15;
                                        break;

                                    case 11:
                                        _context5.prev = 11;
                                        _context5.t0 = _context5['catch'](0);
                                        _context5.next = 15;
                                        return (0, _effects.put)(_pastPracticeTests.actionCreators.createPastPracticeTestFailed(_context5.t0));

                                    case 15:
                                    case 'end':
                                        return _context5.stop();
                                }
                            }
                        }, _callee3, this, [[0, 11]]);
                    }));

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked3, this);
}

function editPastPracticeTestRequest() {
    return regeneratorRuntime.wrap(function editPastPracticeTestRequest$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(_pastPracticeTests.actionTypes.EDIT_PAST_PRACTICE_TEST_REQUEST, /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref3) {
                        var id = _ref3.id,
                            pastPracticeTest = _ref3.pastPracticeTest,
                            redirect = _ref3.redirect;
                        var response;
                        return regeneratorRuntime.wrap(function _callee4$(_context7) {
                            while (1) {
                                switch (_context7.prev = _context7.next) {
                                    case 0:
                                        _context7.prev = 0;
                                        _context7.next = 3;
                                        return (0, _effects.call)(_api.request, 'put', '/pastpracticetests/' + id, pastPracticeTest);

                                    case 3:
                                        response = _context7.sent;
                                        _context7.next = 6;
                                        return (0, _effects.put)(_pastPracticeTests.actionCreators.editPastPracticeTestSucceeded(response.data));

                                    case 6:
                                        if (!redirect) {
                                            _context7.next = 9;
                                            break;
                                        }

                                        _context7.next = 9;
                                        return (0, _effects.call)(redirect);

                                    case 9:
                                        _context7.next = 15;
                                        break;

                                    case 11:
                                        _context7.prev = 11;
                                        _context7.t0 = _context7['catch'](0);
                                        _context7.next = 15;
                                        return (0, _effects.put)(_pastPracticeTests.actionCreators.editPastPracticeTestFailed(_context7.t0));

                                    case 15:
                                    case 'end':
                                        return _context7.stop();
                                }
                            }
                        }, _callee4, this, [[0, 11]]);
                    }));

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked4, this);
}

function addQuestionsToPastPracticeTestRequest() {
    return regeneratorRuntime.wrap(function addQuestionsToPastPracticeTestRequest$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return (0, _effects.takeLatest)(_pastPracticeTests.actionTypes.ADD_QUESTIONS_TO_PAST_PRACTICE_TEST_REQUEST, /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref4) {
                        var id = _ref4.id,
                            questions = _ref4.questions;
                        return regeneratorRuntime.wrap(function _callee5$(_context9) {
                            while (1) {
                                switch (_context9.prev = _context9.next) {
                                    case 0:
                                        _context9.prev = 0;
                                        _context9.next = 3;
                                        return (0, _effects.call)(_api.request, 'post', '/pastpracticetests/' + id + '/relationships/questions', { questions: questions });

                                    case 3:
                                        _context9.next = 5;
                                        return (0, _effects.put)(_pastPracticeTests.actionCreators.addQuestionsToPastPracticeTestSucceeded());

                                    case 5:
                                        _context9.next = 11;
                                        break;

                                    case 7:
                                        _context9.prev = 7;
                                        _context9.t0 = _context9['catch'](0);
                                        _context9.next = 11;
                                        return (0, _effects.put)(_pastPracticeTests.actionCreators.addQuestionsToPastPracticeTestFailed(_context9.t0));

                                    case 11:
                                    case 'end':
                                        return _context9.stop();
                                }
                            }
                        }, _callee5, this, [[0, 7]]);
                    }));

                case 2:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked5, this);
}

exports.default = [fetchPastPracticeTestsRequest, fetchPastPracticeTestRequest, createPastPracticeTestRequest, editPastPracticeTestRequest, addQuestionsToPastPracticeTestRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/pastPracticeTests.js
// module id = 2242
// module chunks = 0